import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getReclamacionesMrwVenta } from 'services/ventas'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_RECLAMACIONES(action) {
  try {
    const reclamacionesData = yield call(getReclamacionesMrwVenta, action.payload)
    if (reclamacionesData.ok) {
      yield put({
        type: actions.RECLAMACIONES_LOAD_SUCCEEDED,
        payload: reclamacionesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar reclamaciones')
      put({
        type: actions.RECLAMACIONES_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.RECLAMACIONES_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.RECLAMACIONES_LOAD_REQUESTED, GET_RECLAMACIONES)])
}
